import PresentationAcceptButton from './PresentationAcceptButton'
export default PresentationAcceptButton

export * from './PresentationAcceptButton'
